export const TELEMETRY_PROTOCOLS = [
  {
    value: "wialon_ips",
    label: "Wialon IPS",
    endpoint: "telemetry.trucko.ru:5959",
    steps: [
      "Выберите протокол Wialon IPS в настройках устройства.",
      "Укажите сервер, порт и IMEI трекера.",
      "Если используется пароль, укажите значение из этой формы. Сохраните настройки и перезапустите устройство.",
    ],
  },
  {
    value: "teltonika",
    label: "Teltonika",
    endpoint: "telemetry.trucko.ru:5962",
    steps: [
      "Откройте настройки отправки данных устройства Teltonika.",
      "Укажите сервер и порт, затем проверьте IMEI устройства.",
      "Сохраните настройки и перезапустите устройство.",
    ],
  },
  {
    value: "osmand",
    label: "OsmAnd",
    endpoint:
      "http://telemetry.trucko.ru:15002/osmand/position",
    steps: [
      "Откройте настройки отправки координат в OsmAnd или совместимом приложении.",
      "Укажите адрес сервера и идентификатор устройства.",
      "Сохраните настройки и включите отправку координат.",
    ],
  },
];

export function findTelemetryProtocol(value) {
  return (
    TELEMETRY_PROTOCOLS.find((protocol) => protocol.value === value) ||
    null
  );
}
